"use client";

import { useState } from "react";
import { Code } from "lucide-react";
import { Button } from "@/components/ui/button";
import AppEmbedShareDialog from "@/components/ui/app-embed-share-dialog";
import { useThemeConfig } from "@/hooks/use-theme-config";
import { APP_EMBEDS, type AppEmbedType } from "@/lib/embeds/app-embeds";
import { cn } from "@/lib/utils";

/** The code icon an app page section shows to get its embed snippet; the same button as the rank chart's. */
export function AppEmbedButton({ type, appId, country, height, className }: { type: AppEmbedType; appId: number; country?: string; height?: number; className?: string }) {
  const [open, setOpen] = useState(false);
  const { isTerminal, mounted } = useThemeConfig();
  const showTerminal = mounted && isTerminal;
  const label = APP_EMBEDS[type].label;

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          "h-6 w-6 shrink-0 text-muted-foreground hover:text-foreground",
          showTerminal && "text-[var(--ast-brand-moss)] hover:text-[var(--ast-brand-text)] hover:bg-[rgba(var(--ast-brand-night-rgb),0.92)]",
          className
        )}
        onClick={() => setOpen(true)}
        aria-label={label}
        title={label}
      >
        <Code size={14} />
      </Button>
      <AppEmbedShareDialog open={open} onOpenChange={setOpen} type={type} appId={appId} country={country} height={height} />
    </>
  );
}
